import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../api/client";
import { pixelTheme } from "../theme/pixel";
import { defaultBtn, withBtnStyle } from "../theme/styles";
import { inertAttrs, inertOnClick } from "../logic/inert";

/**
 * Terminal screen for banned users. The SPA hard-routes here from
 * `App.tsx` whenever `/api/me` reports `is_banned: true` or any other
 * API call returns 403 `{error: "banned"}`. The only affordance is
 * Log Out — calling `/api/logout` clears the session cookie and
 * returns the user to `/login`.
 */
export function BannedPage() {
  const theme = pixelTheme;
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  async function onLogOut() {
    if (pending) return;
    setPending(true);
    try {
      await api.logout();
    } catch {
      // Best-effort: even if the server call fails we still want to
      // bounce the user off this screen.
    } finally {
      navigate("/login", { replace: true });
    }
  }

  return (
    <div
      style={{
        minHeight: "100%",
        background: theme.pageBg,
        color: theme.ink,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: theme.fontBody,
        padding: 20,
      }}
    >
      <div
        style={{
          background: theme.panel,
          border: `2px solid ${theme.panelEdgeStrong}`,
          padding: 28,
          width: "100%",
          maxWidth: 460,
          display: "grid",
          gap: 18,
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontFamily: theme.fontDisplay,
            fontSize: 18,
            letterSpacing: theme.letterSpacing,
            color: theme.accent,
          }}
        >
          YOU'RE BANNED!
        </div>
        <div style={{ fontSize: 14, color: theme.inkDim, lineHeight: 1.5 }}>
          This account has been locked out by a moderator. If you think
          this was a mistake, contact support.
        </div>
        <button
          type="button"
          onClick={inertOnClick(pending, () => void onLogOut())}
          {...inertAttrs(pending)}
          {...withBtnStyle(defaultBtn(theme, pending), {
            fontSize: 12,
            padding: "10px 16px",
          })}
        >
          {pending ? "…" : "LOG OUT"}
        </button>
      </div>
    </div>
  );
}
